import {
  SHOW_MODAL,
  HIDE_MODAL,
} from '../actions/types'

const initialModalState = {
  contentData: {},
  modalType: null,
  visiableModal: false,
  title: '',
  error: false,
  responseStatus: '',
}

const configModal = (state, action) => {
  const { contentData = {}, modalType } = action
  return {
    ...state,
    contentData,
    modalType,
    visiableModal: true,
  }
}

const modal = (state = initialModalState, action) => {
  switch (action.type) {
    case SHOW_MODAL: {
      return configModal(state, action)
    }
    case HIDE_MODAL:
      return {
        ...state,
        ...initialModalState,
      }
    default:
      return state
  }
}

export default modal



// WEBPACK FOOTER //
// ./src/reducers/modal.js